module.exports = __webpack_public_path__ + "img/index-ico2.869f8611.png";